var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 88,
    viewBox: "0 0 73 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1976 31.0056H8.49276C5.36265 31.0056 2.8252 33.5431 2.8252 36.6732V79.2727C2.8252 82.4028 5.36265 84.9403 8.49276 84.9403H64.1976C67.3277 84.9403 69.8652 82.4028 69.8652 79.2727V36.6732C69.8652 33.5431 67.3277 31.0056 64.1976 31.0056Z",
    stroke: "black",
    strokeWidth: 5.65,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9565 31.3769V18.6856C19.9565 9.92011 27.0517 2.82495 35.8172 2.82495C44.5826 2.82495 51.6778 9.92011 51.6778 18.6856V31.3769",
    stroke: "black",
    strokeWidth: 5.65,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.873 47.0803C39.9085 47.0803 42.3691 49.541 42.3691 52.5764C42.3691 54.5662 41.312 56.309 39.7285 57.2737V66.3245C39.7285 67.8461 38.4982 69.0793 36.9805 69.0793C35.4628 69.0793 34.2325 67.8461 34.2324 66.3245V57.3967C32.5309 56.4625 31.377 54.6546 31.377 52.5764C31.377 49.541 33.8377 47.0804 36.873 47.0803Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.17989b18e396026af38331cec0ef120e.svg";
export { ForwardRef as ReactComponent };